module.exports = {
    TRACKING: {
        kia: {
            'k900': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N9288.2990.EDMUNDS.COMINC/B10731162.143297609;dc_trk_aid=315576573;' +
                'dc_trk_cid=77623341;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'optima-hybrid': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N9288.2990.EDMUNDS.COMINC/B10731162.143297613;dc_trk_aid=315576569;' +
                'dc_trk_cid=77623341;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'soul': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N9288.2990.EDMUNDS.COMINC/B10731162.143297606;dc_trk_aid=315576576;' +
                'dc_trk_cid=77623341;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'cadenza': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N9288.2990.EDMUNDS.COMINC/B10731162.143297612;dc_trk_aid=315576570;' +
                'dc_trk_cid=77623341;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'sedona': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N9288.2990.EDMUNDS.COMINC/B10731162.143297608;dc_trk_aid=315576574;' +
                'dc_trk_cid=77623341;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'niro': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N9288.2990.EDMUNDS.COMINC/B10731162.143297614;dc_trk_aid=315576568;' +
                'dc_trk_cid=77623341;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'sorento': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N9288.2990.EDMUNDS.COMINC/B10731162.143297617;dc_trk_aid=315576565;' +
                'dc_trk_cid=77623341;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'soul-ev': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N9288.2990.EDMUNDS.COMINC/B10731162.143297615;dc_trk_aid=315576567;' +
                'dc_trk_cid=77623341;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'rio': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N9288.2990.EDMUNDS.COMINC/B10731162.143297611;dc_trk_aid=315576571;' +
                'dc_trk_cid=77623341;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'optima': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N9288.2990.EDMUNDS.COMINC/B10731162.143297610;dc_trk_aid=315576572;' +
                'dc_trk_cid=77623341;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'forte': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N9288.2990.EDMUNDS.COMINC/B10731162.143297607;dc_trk_aid=315576575;' +
                'dc_trk_cid=77623341;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'sportage': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N9288.2990.EDMUNDS.COMINC/B10731162.143297616;dc_trk_aid=315576566;' +
                'dc_trk_cid=77623341;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            }
        },
        fiat: {
            '500x': {
                link: 'https://ad.doubleclick.net/ddm/clk/315637829;143205475;k'
            }
        },
        honda: {
            'odyssey': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N8821.2990.EDMUNDS.COMINC/B9577930.142310484;dc_trk_aid=314374213;' +
                'dc_trk_cid=69915957;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'pilot': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N8821.2990.EDMUNDS.COMINC/B9577930.142310485;dc_trk_aid=313784735;' +
                'dc_trk_cid=69916207;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'ridgeline': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N8821.2990.EDMUNDS.COMINC/B9577930.142310486;dc_trk_aid=306749191;' +
                'dc_trk_cid=70025724;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'accord': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N8821.2990.EDMUNDS.COMINC/B9577930.142315323;dc_trk_aid=308370781;' +
                'dc_trk_cid=67552343;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'cr-v': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N8821.2990.EDMUNDS.COMINC/B9577930.142315324;dc_trk_aid=307148826;' +
                'dc_trk_cid=64109368;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'clarity': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N8821.2990.EDMUNDS.COMINC/B9577930.142317090;dc_trk_aid=311019571;' +
                'dc_trk_cid=67847940;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'hr-v': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N8821.2990.EDMUNDS.COMINC/B9577930.142318904;dc_trk_aid=311697448;' +
                'dc_trk_cid=70028662;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'accord-hybrid': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N8821.2990.EDMUNDS.COMINC/B9577930.142319861;dc_trk_aid=308370781;' +
                'dc_trk_cid=67552343;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'fit': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N8821.2990.EDMUNDS.COMINC/B9577930.142320405;dc_trk_aid=311699492;' +
                'dc_trk_cid=69958122;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'cr-z': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N8821.2990.EDMUNDS.COMINC/B9577930.142320801;dc_trk_aid=303483314;' +
                'dc_trk_cid=70027648;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            },
            'civic': {
                link: 'https://ad.doubleclick.net/ddm/trackclk/N8821.2990.EDMUNDS.COMINC/B9577930.142321718;dc_trk_aid=311019571;' +
                'dc_trk_cid=67847940;dc_lat=;dc_rdid=;tag_for_child_directed_treatment='
            }
        },
        dodge: {
            'challenger': {
                link: 'https://ad.doubleclick.net/ddm/clk/315765945;143191769;v'
            },
            'durango': {
                link: 'https://ad.doubleclick.net/ddm/clk/315765916;143191772;n'
            },
            'charger': {
                link: 'https://ad.doubleclick.net/ddm/clk/315765953;143195222;i'
            },
            'journey': {
                link: 'https://ad.doubleclick.net/ddm/clk/315765939;143197044;q'
            }

        },
        chrysler: {
            'pacifica': {
                link: 'https://ad.doubleclick.net/ddm/clk/315678727;143187837;x'
            },
            'conquest': {
                'dodge':{
                    'grand-caravan': {
                        link: 'https://ad.doubleclick.net/ddm/clk/315678727;143187838;y'
                    }
                }
            }
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/creative/core-page/deep-link/deep-link-constants3.js
// module id = 129
// module chunks = 0 1 23